import React from "react";
import "./carousel.css";

export default function RightToLeft({ courier }) {
  return (
    <div className="marquee-container">
      <div className="marquee-track">
        {[...courier, ...courier].map((item, index) => (
          <div key={index} className="marquee-item">
            <img src={item.image} className="img-fluid" alt="" />
          </div>
        ))}
      </div>
    </div>
  );
}